<template>
    <label class="form__cb-group" :for="id" aria-labelledby="label">
        <input
            v-bind="$attrs"
            :class="{ 'checked' : isChecked }"
            :id="id"
            :checked="isChecked"
            type="checkbox"
            v-on="listeners"
        >
        <span class="form__cb-box"><SVGicon-tick /></span>
        <span id="label" :class="['form__cb-label', { 'sr-only' : srOnly }]">{{ formLabel }}</span>
    </label>
</template>

<script>
export default {
    inheritAttrs: false,

    props: {
        id: {
            type: String,
            required: true
        },

        srOnly: {
            type: Boolean,
            default: false
        },

        checked: {
            type: [Boolean, String],
            default: false
        },

        label: {
            type: String,
            required: false
        }
    },

    computed: {
        formLabel () {
            return this.label ? this.label : this.id
        },

        isChecked () {
            if (typeof this.checked == 'string') return this.checked == 'true' ? true : false
            return this.checked
        },

        listeners () {
            return {
                ...this.$listeners,
                input: event => this.$emit('input', event.target.checked),
            }
        }
    }
}
</script>
